import { createMachine, DefaultContext, InterpreterFrom, StateConfig, StateFrom } from 'xstate'

export type RewardsOnboardingEvent = { type: 'CONTINUE' } | { type: 'RESTORE' }

type RewardsOnboardingState = {
  value: 'initial' | 'pending' | 'invalid' | 'complete'
  context: DefaultContext
}

export const machine = createMachine<
  DefaultContext,
  RewardsOnboardingEvent,
  RewardsOnboardingState
>({
  predictableActionArguments: true,
  id: 'rewards_onboarding',
  initial: 'initial',
  context: {},
  states: {
    initial: {
      on: {
        '*': 'pending',
      },
    },
    pending: {
      on: {
        CONTINUE: 'complete',
      },
    },
    invalid: {
      on: {
        RESTORE: 'complete',
      },
    },
    complete: {
      type: 'final',
    },
  },
})

export type RewardsOnboardingMachine = typeof machine

export type RewardsOnboardingInterpreter = InterpreterFrom<RewardsOnboardingMachine>

export type RewardsOnboardingStateConfig = StateConfig<DefaultContext, RewardsOnboardingEvent>

export type RewardsOnboardingStateObject = StateFrom<RewardsOnboardingMachine>

export type RewardsOnboardingObserverCallback = (state: RewardsOnboardingStateObject) => void

export type RewardsOnboardingStateValue = RewardsOnboardingState['value']
